import { render, staticRenderFns } from "./CombinedSearch.vue?vue&type=template&id=aa9d3d0a&scoped=true&"
import script from "./CombinedSearch.vue?vue&type=script&lang=js&"
export * from "./CombinedSearch.vue?vue&type=script&lang=js&"
import style0 from "./CombinedSearch.vue?vue&type=style&index=0&id=aa9d3d0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9d3d0a",
  null
  
)

export default component.exports